export enum ResearchAudienceTypeEnum {
  DIRECT_UPLOAD = 1,
  PANEL_RECRUITMENT = 2,
  EXTERNAL_SAMPLE_RECRUITMENT = 3,
  DIRECT_RECRUITMENT = 4
}
